<template>
  <div class='task-release atb-flex atb-flex-column'>
    <div class='atb-content-bg atb-flex atb-flex-column'>
      <div class='search'>
        <el-form :inline="true" :model="searchParam" class="atb-input" @keyup.enter.native.prevent="getList(1)" @submit.native.prevent>
          <div class="params-wrap">
            <el-form-item class="flex-form-item" label="创建时间">
              <el-date-picker v-model="Time" type="month" placeholder="选择创建时间" value-format="yyyy-MM"></el-date-picker>
            </el-form-item>
            <el-form-item class="flex-form-item" label="工作项分类">
              <common-select ref="workClassify" placeholder="工作项分类" :list="workClassifyList" v-model="searchParam.WorkClassify" optLabel="label" optValue="value" clearable></common-select>
            </el-form-item>
            <el-form-item class="flex-form-item" label="状态">
              <common-select ref="status" placeholder="状态" v-model="searchParam.Status" :url="$api.common.getDict" :ajaxMethod="'get'" :params="{ItemType:'TaskReleaseState'}" 
              :filterData="filterData" optLabel="itemDesc" optValue="itemValue" clearable></common-select>
            </el-form-item>
            <el-form-item class="flex-form-item" label="关键字">
              <el-input v-model="searchParam.KeyWord" placeholder="工作项目" clearable></el-input>
            </el-form-item>
          </div>
          <div class="btn-wrap">
            <el-form-item>
              <el-button type="primary" @click="getList(1)">查询</el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="add" @click="add">新增</el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="sync" @click="addSyncNext">计划同步新增</el-button>
            </el-form-item>
            <el-form-item v-if="$auth(that, 'Batch')">
              <el-button type="add" @click="addBatch">批量新增</el-button>
            </el-form-item>
            <el-form-item v-if="$auth(that, 'Batch')">
              <el-button type="sync" @click="addSyncBatchNext">批量计划同步新增</el-button>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div class="main-content-wrap">
        <div class="table-content-wrap" :style="{'width': currentShowRow ? 'calc(100% - 600px)' : ''}">
          <div class='table-content atb-flex atb-flex-column'>
            <vxe-table
              class='atb-table header-table edit-table'
              border='inner'
              height='100%'
              auto-resize
              resizable
              stripe
              highlight-hover-row
              :data="tableData"
              ref="modifyYear"
              @checkbox-change="handledSelectChange"
              @checkbox-all="selectAllEvent"
              @cell-click="expandRowRight"
            >
              <!-- <vxe-table-column type='checkbox' width='40' align='center'></vxe-table-column> -->
              <vxe-table-column type='seq' width='55' align='center' title="序号"></vxe-table-column>
              <vxe-table-column field="workClassify" title="工作项分类" width="120">
                <template #default="{ row }">{{ workClassifyList.length>0&&workClassifyList.find(t=>t.value==row.workClassify).label || '' }}</template>
              </vxe-table-column>
              <vxe-table-column field="workItemContent" title="工作项目" width="130">
                <template #default="{row}">
                  <div :class="[row.expandRowFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{row.workItemContent}}
                  </div>
                </template>
              </vxe-table-column>
              <vxe-table-column field="resWkName" title="指定人" width="120">
                <template #default="{row}">
                  <el-tooltip class='item' effect='dark' :disabled="row.resWks.length <= 1" :content='formatResWk(row)' popper-class="el-tooltip-400-200">
                    <div :class="[row.expandRowFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{formatResWk(row)}}</div>
                  </el-tooltip>
                </template>
              </vxe-table-column>
              <vxe-table-column field="weight" title="权重" width="80"></vxe-table-column>
              <vxe-table-column field="fullTarget" title="总目标" min-width="160">
                <template #default="{row}">
                  <div :class="[row.expandRowFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{row.fullTarget}}
                  </div>
                </template>
              </vxe-table-column>
              <vxe-table-column field="creationTime" title="创建时间" width="160">
                <template #default="{ row }">{{ row.creationTime? formatDate(new Date(row.creationTime), 'yyyy-MM-dd HH:mm:ss'):0 }}</template>
              </vxe-table-column>
              <vxe-table-column field="startDate" title="开始时间" width="135">
                <template #default="{ row }">{{ row.startDate? formatDate(row.startDate, 'yyyy-MM-dd'): '' }}</template>
              </vxe-table-column>
              <vxe-table-column field="finishDate" title="总目标完成时间" width="135">
                <template #default="{ row }">{{ row.finishDate? formatDate(row.finishDate, 'yyyy-MM-dd'): '' }}</template>
              </vxe-table-column>
              <vxe-table-column field="totalStatus" title="提交状态" width="135" show-overflow>
                <template #default="{ row }">
                  <el-tag
                    v-if='row.totalStatus === 0'
                    type="complete"
                    effect="dark">
                    已保存
                  </el-tag>
                  <el-tag
                    v-if='row.totalStatus === 30'
                    type="close"
                    effect="dark">
                    已驳回
                  </el-tag>
                  <el-tag
                    v-if='row.totalStatus === -1'
                    type="delay"
                    effect="dark">
                    未发布完成
                  </el-tag>
                </template>
              </vxe-table-column>
              <vxe-table-column field="approveReason" title="审批意见" width="130">
                <template #default="{row}">
                  <div :class="[row.expandRowFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{row.approveReason || '无'}}
                  </div>
                </template>
              </vxe-table-column>
              <vxe-table-column field="opera" title="操作" fixed="right" width='160' class-name='operation'>
                <template #default="scope">
                  <el-tooltip class='item' effect='dark' content='发布' placement="bottom" v-if='scope.row.totalStatus === 0 || scope.row.totalStatus === 30'>
                    <i class='icon-send' @click.stop='send({row:scope.row})'></i>
                  </el-tooltip>
                  <el-tooltip class='item' effect='dark' content='编辑' placement="bottom" v-if='scope.row.totalStatus === 0 || scope.row.totalStatus === 30 || scope.row.totalStatus === -1'>
                    <i class='icon-editor' @click.stop='edit({row:scope.row})'></i>
                  </el-tooltip>
                  <el-tooltip class='item' effect='dark' content='删除' placement="bottom" v-if='scope.row.totalStatus === 0 || scope.row.totalStatus === 30'>
                    <i class='icon-close delete' @click.stop='deleteTip({row:scope.row})'></i>
                  </el-tooltip>
                </template>
              </vxe-table-column>
            </vxe-table>
          </div>
          <div class='page-con atb-flex atb-flex-justify-end'>
            <vxe-pager
              background
              :current-page.sync="page.PageIndex"
              :page-size.sync="page.PageSize"
              :total="total"
              height="100%"
              pager-count="4"
              @page-change="handledPageChange"
              :layouts="['PrevJump', 'PrevPage', 'JumpNumber', 'NextPage', 'NextJump', 'Total']"
            >
            </vxe-pager>
          </div>
        </div>
        <div v-if="currentShowRow" v-show="isCollapse" class="row-detail-wrap">
          <row-detail :rowData="currentShowRow" @deleteWorkItem="deleteWorkItem" @allPublishComplete="getList(1)" />
        </div>
        <div v-if="currentShowRow" class="collapse" :style="{right: isCollapse ? '610px' : '20px'}" @click="collapseHandle()">
          <i :class="[isCollapse ? 'icon-shouqi' : 'icon-zhankai']"></i>
        </div>
      </div>
      
      <common-dialog ref="addDialog" :title="dialogContent.title" width="600px" showClose :appendBody="true">
        <template slot="content">
          <component v-bind:is="dialogContent.componentName" :editData="EditRow" :isBatch="isBatch" @submitSuccess="getList(1)"></component>
        </template>
      </common-dialog>
      <common-dialog ref="addSyncDialog" :title="dialogContent.title" :width="dialogContent.width" showClose :appendBody="true">
        <template slot="content">
          <component v-bind:is="dialogContent.componentName" :editData="EditRow" :isBatch="isBatch" @submitSuccess="getList(1)"></component>
        </template>
      </common-dialog>
      <el-dialog title="提示" :visible.sync="showDelTip" width="260px" :close-on-click-modal="false" :close-on-press-escape="false">
        <div class="content">
          <h2>确定要删除吗</h2>
          <p>已删除的工作项不能撤回</p>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button class="atb-dialog-confirm" type="primary" @click="del">确认</el-button>
          <el-button class="atb-dialog-cancel" type="cancel" @click="showDelTip = false">取消</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
  import XEUtils from 'xe-utils'
  export default {
    components: {
      selecter: () => import('@/component/global/customerSelect'),
      add: () => import('./add.vue'),
      addSync: () => import('./addSync.vue'),
      addSyncNext: () => import('./addSyncNext.vue'),
      rowDetail: () => import('./rowDetail.vue'),
    },
    name: "modifyYear",
    data() {
      return {
        that: this,
        id:'id',
        pickerOptions: {
          shortcuts: [{
            text: '今天',
            onClick(picker) {
              picker.$emit('pick', new Date());
            }
          }, {
            text: '昨天',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit('pick', date);
            }
          }, {
            text: '一周前',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', date);
            }
          }]
        },
        workId: '',
        searchParam: {
          WorkItemCategory: null,
          WorkClassify: null,
          KeyWord: null,
          CompleteStatus: null
        },
        Time:new Date(),
        workClassifyList: [],
        categoryList: [],
        completeList: [],
        importantList: [
          {label: '否', value: 0},
          {label: '是', value: 1},
        ],
        programList: [
          {"value": "A2000plus"},
          {"value": "A1000plus"},
          {"value": "远程项目"},
        ],
        status: 0,
        tableData:[],
        seleterData:[],
        weightList:[
          {"value": 5},
          {"value": 10},
          {"value": 15},
          {"value": 20},
          {"value": 25},
        ],
        page: {
          PageIndex: 1,
          PageSize: 10
        },
        total:0,
        dialogContent:{},
        showDelTip:false,
        row:{},
        preventReClick:false,
        isBatch: false,
        currentShowRow: null,
        isCollapse: false,
      }
    },
    computed: {
      workClassifyName(val){
        return this.workClassifyList.length>0&&this.workClassifyList.find(t=>t.value===val).label;
      }
    },
    created() {
    },
    mounted() {
      this.getList(1);
      this.getWorkItemProcessStatusDict();
      // this.getCategory();
      this.getYearPlanWorkItemClassify();
    },
    methods: {
      getList(page) {
        this.currentShowRow = null;
        this.page.PageIndex=page;
          if(this.Time){
            const time=this.formatDate(this.Time,'yyyy-MM');
            if(time){
              this.searchParam.Year=time.split('-')[0];
              this.searchParam.Month=~~(time.split('-')[1]);
              delete this.searchParam.Time;
            }
          }else{
           return this.$message.error('请选择创建时间');
          }
          const pageParam= {SkipCount: (this.page.PageIndex - 1) * this.page.PageSize, MaxResultCount: this.page.PageSize} 
          let param = Object.assign({}, this.searchParam, pageParam)
          this.$ajax.get(this.$api.add.PublishYearWork.list, param).then((res) => {
            if(res.code===0){
              this.tableData = [];
              const tableData = res.data.rows.details;
              tableData.forEach((item, i) => {
                let row = {};
                if (item.items.length > 0) {
                  row = item.items[0];
                  row.totalStatus = row.status;
                  let isReject = true;
                  row.resWks = item.items.map(item2 => {
                    isReject = isReject && item2.status === 30;
                    if (![0, 30].includes(item2.status)) {
                      row.totalStatus = -1;
                    }
                    return {
                      id: item2.id,
                      resWkName: item2.resWkName,
                      resWkNo: item2.resWkNo,
                      ...item2,
                    }
                  })
                  if (isReject) row.totalStatus = 30;
                  this.tableData.push(row);
                }
              })

              this.total=res.data.total;
            }
        });
      },
      formatDate(value, format) {
        return XEUtils.toDateString(value, format)
      },
      deleteTip({row}) {
        this.showDelTip=true;
        this.row=row;
      },
      formatResWk(row) {
        return row.resWks.map(item => item.resWkName).join('，');
      },
      del() {
        if (this.row.groupId || this.row.id) {
          this.$ajax.delete(this.$api.add.PublishYearWork.adu + '/' + this.row.id, {params: {groupId: this.row.groupId}}).then(() => {
            this.$message.success('删除成功');
            this.getList(1);
          }).finally(()=>{
            this.showDelTip = false;
         });
        }
      },
      deleteWorkItem() {
        this.deleteTip({row: this.currentShowRow});
      },
      submit({row}){
        this.$ajax.put(this.$api.add.PublishYearWork.updateStatus, {
          id: row.id,
          workId: row.workId,
          status: 10
        }).then((res) => {
          if(res.code==0){
            this.$message.success('提交成功');
            this.getList(1);
          }
        });
      },
      getSelecterData(data){
        this.seleterData=data;
      },
      querySearchWeight(queryString, cb) {
        let weightList = this.weightList;
        // 调用 callback 返回建议列表的数据
        cb(weightList);
      },
      handledPageChange({ currentPage }) {
        this.getList(currentPage);
      },
      add() {
        this.isBatch = false;
        this.EditRow={};
        this.dialogContent = {
          title: '新增',
          componentName: 'add'
        }
        this.$refs.addDialog.show()
      },
      addSync(){
        this.dialogContent = {
          title: '计划同步新增',
          componentName: 'addSync',
          width: '900px',
        }
        this.$refs.addSyncDialog.show()
      },
      // 新版 动态
      addSyncNext() {
        this.isBatch = false;
        this.dialogContent = {
          title: '计划同步新增',
          componentName: 'addSyncNext',
          width: '900px',
        }
        this.$refs.addSyncDialog.show()
      },
      // 批量新增
      addBatch() {
        this.isBatch = true;
        this.EditRow = {};
        this.dialogContent = {
          title: '新增',
          componentName: 'add'
        }
        this.$refs.addDialog.show()
      },
      // 批量计划同步新增
      addSyncBatchNext() {
        this.isBatch = true;
        this.dialogContent = {
          title: '计划同步新增',
          componentName: 'addSyncNext',
          width: '900px',
        }
        this.$refs.addSyncDialog.show()
      },
      edit({row}){
        this.EditRow = typeof(row) == 'object' ? row || {} : {};
        this.isBatch = row.groupId && row.groupId !== '00000000-0000-0000-0000-000000000000';
        this.EditRow.workClassify=this.EditRow.workClassify? (this.EditRow.workClassify).toString(): '0';
        this.dialogContent = {
          title: '编辑',
          componentName: 'add',
          width: '900px',
        }
        this.$refs.addDialog.show();
      },
      filterData(res){
        return res&&res.data&&res.data.rows;
      },
      getWorkItemProcessStatusDict(){
        this.$ajax.get(this.$api.common.getDict,{ItemType:'WorkItemProcessStatus'}).then(res=>{
          if(res.code===0){
            this.cocompleteList=[];
            res.data.rows.forEach(t=>{
              this.completeList.push({label:t.itemDesc,value:eval(t.itemValue)});
            });
          }
        });
      },
      send({row}){
        const isBatch = row.groupId && row.groupId !== '00000000-0000-0000-0000-000000000000';
        if (isBatch) {
          const params = row.resWks.map(item => {
            return {
              outterId: item.id
            }
          });
          this.$ajax.put(this.$api.add.PublishYearWork.commitWorkItemBatch, params).then((res) => {
            if(res.code===0){
              this.$message.success('发布已提交，正在处理中');
              // this.getList(1);
              this.$router.push('/manage/export-task/index')
            }
          });
        } else {
          this.$ajax.put(this.$api.add.PublishYearWork.commitWorkItem, `"${row.id}"`, { headers: { 'Content-Type': 'application/json;charset=UTF-8;' } }).then((res) => {
            if(res.code === 0){
              this.$message.success('发布成功');
              this.getList(1);
            }
          });
        }
      },
      getCategory() {
        this.$ajax.get(this.$api.Identity.Categord.categoryByNo, {userId: sessionStorage.getItem("LOGIN_NAME")}).then(res => {
          const item = res.data;
          this.categoryList = this.filterCategory(item);
        });
      },
      queryCategory(queryString, cb) {
        let categoryList = this.categoryList;
        // 调用 callback 返回建议列表的数据
        cb(categoryList);
      },
      getYearPlanWorkItemClassify(){
        this.$ajax.get(this.$api.common.getDict,{ItemType:'YearPlanWorkItemClassify'}).then(res=>{
          if(res.code===0){
            this.workClassifyList=[];
            res.data&&res.data.rows.filter(t => ['0', '10', '20', '50', '60'].includes(t.itemValue)).forEach(t=>{
              this.workClassifyList.push({label:t.itemDesc,value:eval(t.itemValue)});
            });
          }
        });
      },
      // eslint-disable-next-line no-unused-vars
      expandRowRight({rowIndex, row, column}) {
        if (column.property === 'opera') return;
        this.isCollapse = true;
        const isBatch = row.groupId && row.groupId !== '00000000-0000-0000-0000-000000000000';
        if (isBatch && row.resWks && row.resWks.length > 0) {
          this.currentShowRow = row;
        } else {
          this.currentShowRow = null;
        }
        this.tableData[rowIndex].expandRowFlag = !this.tableData[rowIndex].expandRowFlag;
        this.$refs.modifyYear.updateData(this.tableData);
      },
      collapseHandle() {
        this.isCollapse = !this.isCollapse;
      }
    }
  }
</script>
<style scoped lang='scss'>
  .task-release {
    height: 100%;
    .atb-content-bg {
      margin-top: 0px;
      padding: 20px;
      flex: 1;
    }
    .page-con {
      flex: 0 0 56px;
    }
  //   ::v-deep .el-tag {
  //   padding: 0 8px;
  //   width: 120px;
  //  }
    ::v-deep .el-dialog__body {
      padding-top: 33px !important;
      text-align: center;
      h2 {
        font-size: 18px;
        color: $--color-text-primary;
        font-weight: bold;
        margin-bottom: 10px;
      }
      p {
        color: $--color-text-regular;
      }
    }
    ::v-deep .el-dialog__footer {
      text-align: center;
    }
    ::v-deep .el-input-group__append {
      padding: 0 5px;
    }
    .search {
      .atb-input{
        .params-wrap{
          display: flex;
          .flex-form-item{
            margin-bottom: 12px;
            display: flex;
            flex: 1;
          }
          .read-mode{
            align-self: flex-end;
          }
          ::v-deep.el-form-item__content{
            flex: 1;
            .el-select, .el-autocomplete{
              width: 100%;
            }
          }
          .el-date-editor.el-input{
            width: 100%;
          }
        }
      }
    }
    .main-content-wrap {
      flex: 1;
      display: flex;
      overflow: hidden;
    }
    .table-content-wrap {
      flex: 1;
      display: flex;
      flex-direction: column;
      height: 100%;
      max-width: 100%;
    }
    .row-detail-wrap {
      width: 600px;
      height: 100%;
      padding-left: 16px;
    }
    .collapse {
      margin-top: -15px;
      position: absolute;
      top: 50%;
      right: 610px;
      width: 15px;
      height: 30px;
      text-align: center;
      line-height: 30px;
      background-color: rgba(#000, 0.1);
      z-index: 99;
      cursor: pointer;
      &:hover {
        background-color: rgba(#000, 0.2);
      }
      i {
        font-size: 14px;
        color: #fff;
      }
    }
  }
  .footer {
    text-align: right;
    margin-top: 20px;
    .select-all-program {
      margin-right: 20px;
    }
  }
  body .atb-input .el-form-item .el-button.el-button--sync {
    background-color: #D3F6E8;
    border-color: #D3F6E8;
    color: #62D48D;
    width: 130px;
  }
</style>
